import React, { createContext, useContext, useState, useEffect } from 'react';
import { useUser } from './UserContext';

const WishlistContext = createContext();

export const useWishlist = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const { user } = useUser();
  const storageKey = user ? `ar_wishlist_${user.id || user.email}` : 'ar_wishlist_guest';

  const [wishlist, setWishlist] = useState(() => {
    try {
      const activeKey = user ? `ar_wishlist_${user.id || user.email}` : 'ar_wishlist_guest';
      return JSON.parse(localStorage.getItem(activeKey)) || JSON.parse(localStorage.getItem('ar_wishlist')) || [];
    } catch { return []; }
  });

  // When user changes (login/logout/switch), reload that user's wishlist
  useEffect(() => {
    try {
      const key = user ? `ar_wishlist_${user.id || user.email}` : 'ar_wishlist_guest';
      const saved = JSON.parse(localStorage.getItem(key)) || (user ? [] : JSON.parse(localStorage.getItem('ar_wishlist')) || []);
      setWishlist(saved);
    } catch {
      setWishlist([]);
    }
  }, [user]);

  // Persist to customer's storage key
  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(wishlist));
    } catch {}
  }, [wishlist, storageKey]);

  const toggleWishlist = (product) => {
    setWishlist(prev => {
      const exists = prev.some(p => p.id === product.id);
      return exists ? prev.filter(p => p.id !== product.id) : [...prev, product];
    });
  };

  const isWishlisted = (id) => wishlist.some(p => p.id === id);

  return (
    <WishlistContext.Provider value={{ wishlist, toggleWishlist, isWishlisted }}>
      {children}
    </WishlistContext.Provider>
  );
};
